// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggestions-list {
    border: 1px solid #ccc;
    position: fixed;
    background-color: white;
    top: -1000px;
    z-index: 1000;
    width: 150px;
    max-height: 250px;
    overflow-y: auto;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    margin: 0;
    padding: 0;
    list-style: none;
}`, "",{"version":3,"sources":["webpack://./src/MyEditor/SuggestionsDropdown/SuggestionsList.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB","sourcesContent":[".suggestions-list {\n    border: 1px solid #ccc;\n    position: fixed;\n    background-color: white;\n    top: -1000px;\n    z-index: 1000;\n    width: 150px;\n    max-height: 250px;\n    overflow-y: auto;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
